import { Avatar, FlexBox, Text } from '@dixa/lib-shared-habla';
import { convertChannelCasing } from 'lib-shared-api-utils';
import { ConversationsChannels } from 'lib-shared-legacy-types';
import type { MainConversation } from 'lib-shared-types-api';

import { ConversationChannelIcon } from 'components/conversation/conversationChannelIcon/conversationChannelIcon';
import { ConversationStatusColorBox } from 'components/conversation/conversationStatusColorBox';
import { getUserDisplayName } from 'utils/user';

type ConversationPreviewDetailsProps = {
  conversation: MainConversation;
};

export const ConversationPreviewDetails = ({
  conversation,
}: ConversationPreviewDetailsProps): JSX.Element => {
  const requester = conversation.authors[conversation.requested_by];

  const subject = conversation.is_abandoned
    ? 'Abandoned'
    : conversation.attributes.subject;

  return (
    <FlexBox flexDirection="row" alignItems="start" gap="300">
      <FlexBox gap="100" alignItems="center">
        <ConversationStatusColorBox
          csid={conversation.id}
          status={conversation.status}
          height="40px"
          flex="0 0 4px"
          borderRadius="100"
        />

        <Avatar size="40" user={requester} />
      </FlexBox>

      <FlexBox flexDirection="column" flex="1" alignSelf="center">
        <FlexBox alignItems="center" gap="200">
          <ConversationChannelIcon
            channel={
              convertChannelCasing(
                conversation.initial_channel,
                'truncate',
              ) as ConversationsChannels
            }
            size={20}
          />

          <Text.Paragraph variant="1">
            {getUserDisplayName(requester) ?? 'Unknown'}
          </Text.Paragraph>
        </FlexBox>

        {subject && (
          <Text.Paragraph variant="2" subdued>
            {subject}
          </Text.Paragraph>
        )}
      </FlexBox>
    </FlexBox>
  );
};
